import { Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import {
  getClientLegal,
  saveClientLegal,
  getAllActiveIdentifiersByWorkspace,
  ILegalIdentifierSettings,
} from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import { failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { defaultLegalData } from '../helper/ClientListingHelper';
import IClientLegel from '../types/IClientLegel';

import ClientLegalIdentifierForm from './clientLegalIdentifierComponents/ClientLegalIdentifierForm';

interface ClientLegalIdentifiersProps {
  setFormWizardCurrentChildStep?: (step: number) => void;
  clientId?: string;
  listPage?: boolean;
  showModal?: () => void;
  loadTabData?: (pageNo: number) => void;
  editObj?: IClientLegel;
  editFlag?: boolean;
}

const ClientLegalIdentifiers = ({
  setFormWizardCurrentChildStep,
  clientId,
  listPage = false,
  showModal,
  loadTabData,
  editObj,
  editFlag,
}: ClientLegalIdentifiersProps) => {
  const [legalIdentifiers, setLegalIdentifiers] = useState<IClientLegel[]>([]);

  const setNotification = useNotificationStore((state) => state.setNotification);

  const [legalIdentifierTypes, setLegalIdentifierTypes] = useState<ILegalIdentifierSettings[]>([]);

  const getLegalIdentifierList = async () => {
    const response = await getAllActiveIdentifiersByWorkspace();
    setLegalIdentifierTypes(response.data);
  };

  useEffect(() => {
    getLegalIdentifierList();
    const clientLegelList: IClientLegel[] = [];
    const getClientLegals = async () => {
      if (clientId) {
        const response = await getClientLegal(clientId);
        if (response?.data?.data) {
          response.data.data?.map((legalListData) => {
            const legalIdentifierDataObj: IClientLegel = {
              data: { ...legalListData },
              isEditable: false,
            };
            clientLegelList.push(legalIdentifierDataObj);
          });
        }
        clientLegelList.push(defaultLegalData(clientId));
        setLegalIdentifiers(clientLegelList);
      }
    };

    if (clientId && !listPage) getClientLegals();
    else {
      if (editFlag) {
        clientLegelList.push(editObj ?? defaultLegalData(clientId ?? ''));
        setLegalIdentifiers(clientLegelList);
      } else {
        clientLegelList.push(defaultLegalData(clientId ?? ''));
        setLegalIdentifiers(clientLegelList);
      }
    }
  }, [clientId, editFlag, editObj, listPage]);

  const validateToContinue = async () => {
    const filteredLegalIdentifiers = [...legalIdentifiers];
    for (let i = 0; i < filteredLegalIdentifiers.length - 1; i++) {
      if (filteredLegalIdentifiers[i].isEditable) {
        return false;
      }
    }
    const lastVal = filteredLegalIdentifiers[filteredLegalIdentifiers.length - 1];
    if (!isEmpty(lastVal.data.legalIdentifierDTO.id) && !isEmpty(lastVal.data.value)) {
      await saveClientLegal(lastVal.data);
    } else if (!(isEmpty(lastVal.data.legalIdentifierDTO.id) && isEmpty(lastVal.data.value))) {
      return false;
    }
    return true;
  };

  const onContinue = async () => {
    if (!validateToContinue()) {
      setNotification(failed('Please save the details and then continue!!'));
      return;
    }
    if (!listPage) setFormWizardCurrentChildStep && setFormWizardCurrentChildStep(2);
    else {
      loadTabData && loadTabData(0);
      showModal && showModal();
    }
  };

  const onSkip = () => setFormWizardCurrentChildStep && setFormWizardCurrentChildStep(2);
  const onBack = () => setFormWizardCurrentChildStep && setFormWizardCurrentChildStep(0);

  return (
    <Grid p={2}>
      {legalIdentifiers?.map((val, index) => (
        <ClientLegalIdentifierForm
          key={index}
          index={index}
          clientLegal={val}
          legalIdentifierTypes={legalIdentifierTypes}
          getLegalIdentifierList={getLegalIdentifierList}
          editFlag={editFlag}
          showModal={showModal}
          loadTabData={loadTabData}
        />
      ))}
      <Stack p={1} spacing={2} direction="row" display="flex" justifyContent="right">
        {!listPage && (
          <>
            <WsButton variant="contained" size="medium" onClick={() => onBack()}>
              {'Back'}
            </WsButton>
            <WsButton variant="contained" size="medium" onClick={() => onSkip()}>
              {'Skip'}
            </WsButton>
            <WsButton variant="contained" size="medium" onClick={() => onContinue()}>
              {`Continue`}
            </WsButton>
          </>
        )}
      </Stack>
    </Grid>
  );
};

export default ClientLegalIdentifiers;
